const toFixedNumber = (number, digits, base) => {
  const pow = Math.pow(base || 10, digits);
  return Math.round(number * pow) / pow;
};

export default toFixedNumber;
